export const DEFAULT_TO_ORDER_QUANTITY = 1;
